import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label:
      'Consent for Psychotherapy/Counselling and Confidentiality Agreement',
    educationalSlide: `
    As a new therapy client with your therapist, you are required to provide informed consent before starting therapy.\n\nPlease take a moment to fill out this short form.`,
    field: 'firstsession_consent_intro',
    type: 'info',
    answer: {}
  },
  {
    label: 'Overview',
    educationalSlide: `You have the right to ask questions about treatment methods so you can make informed decisions about what methods are most suitable for you.\n\nThere is no specific determination on how many therapy sessions are needed, as this will depend on your progress and if you are receiving value from the therapeutic relationship. This can be discussed with your therapist.\n\nThe relationship between you, the client/patient, and your therapist should remain strictly professional.`,
    field: 'firstsession_consent_overview',
    type: 'info',
    answer: {
      type: 'consent-check',
      label:
        'I am aware that I can end my therapy anytime by informing my therapist, and that my therapist has the right to end therapy at anytime.',
      name: 'firstsession_consent_overview_consent',
      required: true
    }
  },
  {
    label: 'Confidentiality',
    educationalSlide: `Sessions between the therapist and the client/patient are strictly confidential. Any notes (paper-based and electronic) taken by the therapist, audio recordings, video recordings during therapy shall be kept confidential and secure by the therapist at all times and shall not disclose it to anyone without any prior written consent by the client/patient, with exception to certain limitations by law such as:

    1. Suspected Abuse to a child, disabled, elderly, other people;
    2. Criminal Acts;
    3. Sexual Abuse;
    4. Any other instance where the therapist has a duty or he or she has a firm belief that there is a necessity to disclose.
    
    In cases where disclosing information with someone else, such as a physician, may be helpful for therapy, therapists will request the client's permission and ask them to sign a form for the release and/or request of information.
    
    Couples attending individual sessions may request that any shared information is kept confidential, as long as it does not compromise the integrity of ongoing couple therapy.
    
    In case you have any questions regarding confidentiality, please discuss this with your therapist.`,
    field: 'firstsession_consent_session_confidentiality',
    type: 'info',
    answer: {
      type: 'consent-check',
      label:
        'I understand the confidentiality that is required by the therapist to perform, as well as the limitations by which the therapist should abide by law',
      name: 'firstsession_consent_confidentiality_consent',
      required: true
    }
  },
  {
    label: 'Cancellations and Missed Sessions',
    educationalSlide: `If you miss an appointment without notice or cancel a session with less than 24 hours' notice, you may be charged the full fee for that session. Legal means may be used to collect unpaid debts.`,
    field: 'firstsession_consent_session_cancellations_and_missed_sessions',
    type: 'info',
    answer: {
      type: 'consent-check',
      label: `I understand my therapist's responsibilities as well as my rights, limitations, and responsibilities as a client/patient`,
      name: 'firstsession_consent_session_cancellations_and_missed_sessions_consent',
      required: true
    }
  },
  {
    label:
      'Consenting Age: I, the client/patient, am above legal age, or am the parent/guardian of the patient/client, and I hereby voluntarily give my informed consent to this agreement with full knowledge of my rights and obligations',
    field: 'firstsession_consent_consenting_age',
    type: 'info',
    answer: {
      type: 'consent-check',
      name: 'firstsession_consent_consenting_age',
      required: true
    }
  },
  {
    label:
      'By adding my electronic signature below, I understand that my therapist will collect some personal information about me, and I agree to the consent and confidentiality agreement outlined in this form.\n\nPlease sign your full name below',
    field: 'firstsession_consent_esign',
    type: 'esign',
    answer: {
      type: 'esign',
      required: true,
      name: 'esign'
    }
  }
];

export default questionsModels;
